var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "resize",
          rawName: "v-resize",
          value: _vm.calculateChartWindowSize,
          expression: "calculateChartWindowSize"
        }
      ],
      attrs: { tabindex: "0" },
      on: {
        keydown: function($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
          ) {
            return null
          }
          _vm.closeOverlays = false
        }
      }
    },
    [
      _c("sidedrawer", {
        attrs: {
          drawer: _vm.drawer,
          selectedDimension: _vm.selectedDimension,
          selectedComplement: _vm.selectedComplement,
          filterDimension: _vm.filterDimension
        },
        on: {
          "update:filterDimension": function($event) {
            _vm.filterDimension = $event
          },
          "update:drawer:width": function($event) {
            _vm.drawerWidth = $event
          },
          "update:drawer:value": function($event) {
            _vm.drawer = $event
          }
        }
      }),
      _vm._v(" "),
      _c(
        "v-toolbar",
        {
          attrs: {
            id: "main-menubar",
            app: "",
            "clipped-left": "",
            flat: "",
            color: "secondary"
          }
        },
        [
          _c(
            "v-toolbar-title",
            [
              _c(
                "v-layout",
                [
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm6: "" } },
                    [
                      _vm._v("\n          Explore\n          "),
                      _vm._v(" "),
                      _c(
                        "v-menu",
                        {
                          staticClass: "scroll-y overflow-y-auto",
                          attrs: {
                            id: "indicator-selector",
                            origin: "center center",
                            transition: "scale-transition",
                            bottom: "",
                            "offset-y": "",
                            "max-height": _vm.mainSelectsHeight
                          }
                        },
                        [
                          _c(
                            "v-btn",
                            { attrs: { slot: "activator" }, slot: "activator" },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.selectedIndicator.text) +
                                  "\n            "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list",
                            { attrs: { dense: "" } },
                            [
                              _vm._l(_vm.indicators, function(i, index) {
                                return [
                                  i.header
                                    ? _c(
                                        "v-subheader",
                                        {
                                          key: i.header,
                                          staticClass: "indicator-subheader",
                                          attrs: { inset: "" }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(i.header) +
                                              "\n                "
                                          )
                                        ]
                                      )
                                    : typeof i.header === "undefined"
                                      ? _c(
                                          "v-tooltip",
                                          {
                                            key: index,
                                            attrs: {
                                              disabled: i.description === null,
                                              right: "",
                                              "allow-overflow": true,
                                              "max-width": "300"
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                attrs: { slot: "activator" },
                                                slot: "activator"
                                              },
                                              [
                                                _c(
                                                  "v-list-tile",
                                                  {
                                                    on: {
                                                      click: function($event) {
                                                        _vm.selectedIndicator = i
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("v-list-tile-content", [
                                                      _vm._v(
                                                        "\n                        " +
                                                          _vm._s(i.text) +
                                                          "\n                      "
                                                      )
                                                    ])
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(i.description) +
                                                "\n                "
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                ]
                              })
                            ],
                            2
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-menu",
                        {
                          staticClass: "scroll-y overflow-y-auto",
                          attrs: {
                            origin: "center center",
                            transition: "scale-transition",
                            bottom: "",
                            "offset-y": "",
                            "max-height": _vm.mainSelectsHeight
                          }
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                slot: "activator",
                                id: "normalization-selector"
                              },
                              slot: "activator"
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.selectedNormalization.id ===
                                    _vm.constants.NO_NORM.id
                                      ? "not normalised"
                                      : " " + _vm.selectedNormalization.value
                                  ) +
                                  "\n            "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list",
                            { attrs: { dense: "" } },
                            [
                              _vm._l(_vm.selectedIndicator.norm_by, function(
                                n,
                                index
                              ) {
                                return Array.isArray(
                                  _vm.selectedIndicator.norm_by
                                )
                                  ? [
                                      _c(
                                        "v-tooltip",
                                        {
                                          key: "normalization_option_" + index,
                                          attrs: {
                                            disabled:
                                              typeof n.description ===
                                              "undefined",
                                            right: "",
                                            "allow-overflow": true,
                                            "max-width": "300"
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              attrs: { slot: "activator" },
                                              slot: "activator"
                                            },
                                            [
                                              _c(
                                                "v-list-tile",
                                                {
                                                  on: {
                                                    click: function($event) {
                                                      _vm.selectedNormalization = n
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("v-list-tile-content", [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(n.value) +
                                                        "\n                      "
                                                    )
                                                  ])
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(n.description) +
                                              "\n                "
                                          )
                                        ]
                                      )
                                    ]
                                  : _vm._e()
                              })
                            ],
                            2
                          )
                        ],
                        1
                      ),
                      _vm._v("\n          , grouped by\n          "),
                      _vm._v(" "),
                      _c(
                        "v-menu",
                        {
                          staticClass: "scroll-y overflow-y-auto",
                          attrs: {
                            id: "level-selector",
                            origin: "center center",
                            transition: "scale-transition",
                            bottom: "",
                            "offset-y": "",
                            "max-height": _vm.mainSelectsHeight
                          }
                        },
                        [
                          _c(
                            "v-btn",
                            { attrs: { slot: "activator" }, slot: "activator" },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.selectedDimension.name) +
                                  "\n            "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list",
                            { attrs: { dense: "" } },
                            [
                              _vm._l(_vm.constants.DIMENSION_GROUPS, function(
                                g,
                                index
                              ) {
                                return [
                                  _c(
                                    "v-subheader",
                                    {
                                      key: g.header + index,
                                      attrs: { inset: "" }
                                    },
                                    [_vm._v(_vm._s(g.header))]
                                  ),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.constants.DIMENSIONS.filter(function(
                                      d
                                    ) {
                                      return d.dimensionType === g.dimensionType
                                    }),
                                    function(d, index2) {
                                      return _c(
                                        "v-list-tile",
                                        {
                                          key: d.name + index2,
                                          attrs: {
                                            disabled: _vm.disableItems(
                                              d,
                                              "dimension"
                                            )
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.selectItems(
                                                d,
                                                "dimension"
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c("v-list-tile-content", [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(d.name) +
                                                "\n                  "
                                            )
                                          ])
                                        ],
                                        1
                                      )
                                    }
                                  )
                                ]
                              })
                            ],
                            2
                          )
                        ],
                        1
                      ),
                      _vm._v("\n          in\n          "),
                      _vm._v(" "),
                      _c(
                        "v-menu",
                        {
                          staticClass: "scroll-y overflow-y-auto",
                          attrs: {
                            origin: "center center",
                            transition: "scale-transition",
                            bottom: "",
                            "offset-y": "",
                            "max-height": _vm.mainSelectsHeight
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "activator",
                              fn: function(ref) {
                                var menu = ref.on
                                return [
                                  _c(
                                    "v-tooltip",
                                    {
                                      attrs: {
                                        left: "",
                                        disabled:
                                          _vm.selectedYear.alert === false
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function(ref) {
                                              var tooltip = ref.on
                                              return [
                                                _c(
                                                  "span",
                                                  _vm._g({}, tooltip),
                                                  [
                                                    _c(
                                                      "v-btn",
                                                      _vm._g({}, menu),
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.selectedYear
                                                                .year
                                                            )
                                                          )
                                                        ])
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    },
                                    [
                                      _vm._v(" "),
                                      _vm.selectedYear.alert
                                        ? _c(
                                            "span",
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  attrs: { dark: "", small: "" }
                                                },
                                                [_vm._v("warning")]
                                              ),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.selectedYear.message
                                                  )
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                ]
                              }
                            }
                          ])
                        },
                        [
                          _vm._v(" "),
                          _c(
                            "v-list",
                            { attrs: { dense: "" } },
                            _vm._l(_vm.years, function(y, yindex) {
                              return _c(
                                "v-tooltip",
                                {
                                  key: yindex,
                                  attrs: {
                                    left: "",
                                    disabled: y.alert === false
                                  }
                                },
                                [
                                  _c(
                                    "v-list-tile",
                                    {
                                      staticClass: "year-container",
                                      attrs: { slot: "activator" },
                                      on: {
                                        click: function($event) {
                                          _vm.selectedYear = y
                                        }
                                      },
                                      slot: "activator"
                                    },
                                    [
                                      _c(
                                        "v-list-tile-title",
                                        { staticClass: "year" },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(y.year) +
                                              "\n                "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  y.alert
                                    ? _c(
                                        "span",
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { dark: "", small: "" } },
                                            [_vm._v("warning")]
                                          ),
                                          _vm._v(" " + _vm._s(y.message))
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _c(
            "v-tooltip",
            { attrs: { id: "goto-landingpage", bottom: "" } },
            [
              _c(
                "v-btn",
                {
                  attrs: { slot: "activator", icon: "", to: "/" },
                  slot: "activator"
                },
                [_c("v-icon", [_vm._v("home")])],
                1
              ),
              _vm._v("\n      Go to start page\n    ")
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-tooltip",
            { attrs: { bottom: "" } },
            [
              _c(
                "v-btn",
                {
                  attrs: { slot: "activator", icon: "" },
                  on: {
                    click: function($event) {
                      _vm.showDownloadDialog = true
                    }
                  },
                  slot: "activator"
                },
                [_c("v-icon", [_vm._v("cloud_download")])],
                1
              ),
              _vm._v("\n      Download dialogue\n    ")
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-tooltip",
            { attrs: { bottom: "" } },
            [
              _c(
                "v-btn",
                {
                  attrs: { slot: "activator", icon: "" },
                  on: {
                    click: function($event) {
                      _vm.showTour = !_vm.showTour
                    }
                  },
                  slot: "activator"
                },
                [_c("v-icon", [_vm._v("directions")])],
                1
              ),
              _vm._v("\n      Introductory tour\n    ")
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-tooltip",
            { attrs: { bottom: "" } },
            [
              _c(
                "v-btn",
                {
                  attrs: { slot: "activator", icon: "" },
                  on: { click: _vm.toggleStartDialog },
                  slot: "activator"
                },
                [_c("v-icon", [_vm._v("help")])],
                1
              ),
              _vm._v("\n      About\n    ")
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-content",
        [
          _c(
            "v-layout",
            [
              _c(
                "v-flex",
                { attrs: { xs12: "" } },
                [
                  _c(
                    "v-toolbar",
                    { attrs: { id: "secondary-menubar", color: "white" } },
                    [
                      _c(
                        "v-toolbar-title",
                        [
                          _vm._v("\n              Show\n              "),
                          _vm._v(" "),
                          _c(
                            "v-menu",
                            {
                              staticClass: "scroll-y overflow-y-auto",
                              attrs: {
                                id: "complement-selector",
                                origin: "center center",
                                transition: "scale-transition",
                                bottom: "",
                                "offset-y": "",
                                "max-height": _vm.secondarySelectsHeight
                              }
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: { slot: "activator" },
                                  slot: "activator"
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.selectedComplement.name) +
                                      "\n                "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list",
                                { attrs: { dense: "" } },
                                [
                                  _vm._l(
                                    _vm.constants.DIMENSION_GROUPS,
                                    function(g) {
                                      return [
                                        _c(
                                          "v-subheader",
                                          {
                                            key: g.header,
                                            attrs: { inset: "" }
                                          },
                                          [_vm._v(_vm._s(g.header))]
                                        ),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.constants.DIMENSIONS.filter(
                                            function(d) {
                                              return (
                                                d.dimensionType ===
                                                g.dimensionType
                                              )
                                            }
                                          ),
                                          function(d) {
                                            return _c(
                                              "v-list-tile",
                                              {
                                                key: d.name,
                                                attrs: {
                                                  disabled: _vm.disableItems(
                                                    d,
                                                    "complement"
                                                  )
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.selectItems(
                                                      d,
                                                      "complement"
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("v-list-tile-content", [
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(d.name) +
                                                      "\n                      "
                                                  )
                                                ])
                                              ],
                                              1
                                            )
                                          }
                                        )
                                      ]
                                    }
                                  )
                                ],
                                2
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-menu",
                            {
                              staticClass: "scroll-y overflow-y-auto",
                              attrs: {
                                origin: "center center",
                                transition: "scale-transition",
                                bottom: "",
                                "offset-y": "",
                                "max-height": _vm.secondarySelectsHeight,
                                "close-on-content-click": false
                              }
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: { slot: "activator" },
                                  slot: "activator"
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.selectedComplementItem.text)
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list",
                                { attrs: { dense: "" } },
                                [
                                  _c(
                                    "v-list-tile",
                                    {
                                      on: {
                                        click: function($event) {
                                          _vm.selectedComplementItem =
                                            _vm.constants.AGGREGATE_COMPLEMENTS
                                        }
                                      }
                                    },
                                    [
                                      _c("v-list-tile-content", [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.constants
                                                .AGGREGATE_COMPLEMENTS.text
                                            ) +
                                            "\n                    "
                                        )
                                      ])
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-tile",
                                    {
                                      on: {
                                        click: function($event) {
                                          _vm.selectedComplementItem =
                                            _vm.constants.EACH_SELECTED_COMPLEMENT
                                        }
                                      }
                                    },
                                    [
                                      _c("v-list-tile-content", [
                                        _vm._v(
                                          "\n                      each (selected)\n                    "
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "v-list-tile-action",
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: { icon: "", disabled: "" }
                                            },
                                            [
                                              _c("v-icon", [
                                                _vm._v("bar_chart")
                                              ]),
                                              _vm._v(" "),
                                              _c("v-icon", [
                                                _vm._v("table_chart")
                                              ])
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-tile",
                                    {
                                      on: {
                                        click: function($event) {
                                          return _vm.editSelection()
                                        }
                                      }
                                    },
                                    [
                                      _c("v-list-tile-content", [
                                        _vm._v(
                                          "\n                      edit selection ...\n                    "
                                        )
                                      ])
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("v-divider"),
                                  _vm._v(" "),
                                  _c("v-subheader", { attrs: { inset: "" } }, [
                                    _vm._v("Selection")
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(_vm.selectedItems, function(item) {
                                    return _c(
                                      "v-list-tile",
                                      {
                                        key: item.code,
                                        on: {
                                          click: function($event) {
                                            _vm.selectedComplementItem = item
                                          }
                                        }
                                      },
                                      [
                                        _c("v-list-tile-content", [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(item.text) +
                                              "\n                    "
                                          )
                                        ])
                                      ],
                                      1
                                    )
                                  }),
                                  _vm._v(" "),
                                  _c("v-divider"),
                                  _vm._v(" "),
                                  _vm.allSelectedItems.length >
                                  _vm.displaySelectedCount
                                    ? _c(
                                        "v-list-tile",
                                        {
                                          on: {
                                            click: function($event) {
                                              return _vm.displayMoreSelected()
                                            }
                                          }
                                        },
                                        [
                                          _c("v-list-tile-content", [
                                            _vm._v(
                                              "\n                      ... show more\n                    "
                                            )
                                          ])
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                2
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.dataLoading
                            ? _c(
                                "span",
                                [
                                  _c("v-progress-circular", {
                                    attrs: { size: 20, indeterminate: "" }
                                  }),
                                  _vm._v(
                                    "\n                loading data\n              "
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.noData
                            ? _c(
                                "span",
                                { staticStyle: { color: "red" } },
                                [
                                  _c("v-icon", { attrs: { color: "red" } }, [
                                    _vm._v(
                                      "\n                warning\n                "
                                    )
                                  ]),
                                  _vm._v(
                                    "\n                  no data to display "
                                  ),
                                  _vm.emptyFilter
                                    ? _c("span", [_vm._v("(empty filter)")])
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-container",
                        {
                          staticStyle: { height: "64px", "max-width": "300px" },
                          attrs: {
                            fluid: "",
                            "justify-end": "",
                            "fill-height": "",
                            "ma-0": "",
                            "pa-0": ""
                          }
                        },
                        [
                          _c(
                            "v-toolbar-items",
                            [
                              _c(
                                "v-btn",
                                {
                                  staticStyle: { "max-width": "100px" },
                                  attrs: {
                                    flat: "",
                                    id: "activate-map",
                                    disabled:
                                      _vm.selectedDimension.dimensionType ===
                                        "topic" ||
                                      (_vm.selectedDimension.dimensionType ===
                                        "location" &&
                                        _vm.selectedComplementItem.value ===
                                          "each"),
                                    "active-class": "grey lighten-2",
                                    "input-value":
                                      _vm.selectedVisualization ===
                                      "activate-map",
                                    large: ""
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.selectedVisualization = "activate-map"
                                    }
                                  }
                                },
                                [
                                  _c("v-icon", [_vm._v("map")]),
                                  _vm._v(
                                    "\n                Map\n              "
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  staticStyle: { "max-width": "100px" },
                                  attrs: {
                                    flat: "",
                                    "active-class": "grey lighten-2",
                                    "input-value":
                                      _vm.selectedVisualization ===
                                      "activate-barchart",
                                    large: ""
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.selectedVisualization =
                                        "activate-barchart"
                                    }
                                  }
                                },
                                [
                                  _c("v-icon", [_vm._v("bar_chart")]),
                                  _vm._v(
                                    "\n                Bar\n              "
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  staticStyle: { "max-width": "100px" },
                                  attrs: {
                                    id: "activate-table",
                                    flat: "",
                                    "active-class": "grey lighten-2",
                                    "input-value":
                                      _vm.selectedVisualization ===
                                      "activate-table",
                                    large: ""
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.selectedVisualization =
                                        "activate-table"
                                    }
                                  }
                                },
                                [
                                  _c("v-icon", [_vm._v("table_chart")]),
                                  _vm._v(
                                    "\n                Table\n              "
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c(
                        "v-layout",
                        { attrs: { "fill-height": "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("charts", {
                                attrs: {
                                  "vis-width": _vm.chartContainerWidth,
                                  "vis-height": _vm.chartContainerHeight,
                                  "fact-sheet": _vm.factSheet
                                },
                                on: {
                                  "click:item": function($event) {
                                    return _vm.clickItem($event)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-snackbar",
        {
          attrs: { timeout: 10000, top: "", color: "grey" },
          model: {
            value: _vm.serverError,
            callback: function($$v) {
              _vm.serverError = $$v
            },
            expression: "serverError"
          }
        },
        [
          _vm._v(
            "\n    Requested indicator/filters yielded a server-side error (HTTP 5xx code)."
          ),
          _c("br"),
          _vm._v("\n    Please report to dev@knowmak.eu\n  ")
        ]
      ),
      _vm._v(" "),
      _c("start-dialog", { attrs: { dialogContents: _vm.dialogContents } }),
      _vm._v(" "),
      _vm.showDownloadDialog
        ? _c("download-dialog", {
            attrs: { active: _vm.showDownloadDialog },
            on: {
              "update:active": function($event) {
                _vm.showDownloadDialog = $event
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("tour", {
        attrs: { showTour: _vm.showTour },
        on: {
          toggleTour: function($event) {
            _vm.showTour = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-aae30ed8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aae30ed8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard.vue
// module id = null
// module chunks = 